import { cva, cx, css } from "@/styled-system/css";
const joinedSplitShellCva = cva({
  base: {
    display: "flex",
    width: "100%",
    minWidth: 0,
    alignItems: "stretch",
    borderRadius: "{radii.obj.default}",
    overflow: "visible",
    cursor: "text"
  },
  variants: {
    error: {
      true: {
        backgroundColor: "AdornedInput.bg.error",
        borderWidth: "{borderWidths.xs}",
        borderStyle: "solid",
        borderColor: "border.feedback.critical.hero",
        transition: {
          _motionReduce: "none",
          _motionSafe: "border-color 200ms ease"
        },
        "&:hover:not(:focus-within)": {
          borderColor: "AdornedInput.border.errorHover"
        }
      },
      false: {
        backgroundColor: "bg.screen.softest",
        boxShadow: "inset 0 0 0 {borderWidths.default} var(--shadow-color)",
        boxShadowColor: "border.muted",
        transition: {
          _motionReduce: "none",
          _motionSafe: "box-shadow 200ms ease, background-color 200ms ease"
        }
      }
    }
  },
  defaultVariants: {
    error: false
  }
});
const joinedSplitShell = (error) => joinedSplitShellCva({
  error
});
const joinedSplitSegment = css({
  minWidth: 0,
  borderRadius: 0,
  isolation: "isolate",
  zIndex: 0,
  columnGap: 0,
  gap: 0,
  backgroundColor: "transparent !important",
  boxShadow: "inset 0 0 0 {borderWidths.default} var(--shadow-color)",
  boxShadowColor: "transparent",
  transition: {
    _motionReduce: "none",
    _motionSafe: "box-shadow 200ms ease, background-color 200ms ease"
  },
  "& input": {
    backgroundColor: "transparent"
  },
  "&:hover:not(:focus-within)": {
    boxShadow: "inset 0 0 0 {borderWidths.default} var(--shadow-color) !important",
    boxShadowColor: "border.action.hero.selected.default !important"
  },
  "&:focus-within": {
    position: "relative",
    zIndex: 2,
    overflow: "visible"
  },
  // Override Constellation has(input:focus-visible) which applies {shadows.focus} containing
  // a white gap layer (0 0 1px 2px white) that bleeds across the seam into the adjacent half.
  // Replacing with the v8 SkunkWorks Input.focus equivalent (no white layer):
  //   blue300 #BFDFFF -> colors.blue.200 (H=210 L=88.6%, <1% off)
  //   blue400 #0041D9 -> colors.blue.600 (H=222 L=42.5%, exact)
  // Pinned against @zillow/constellation-10@10.24.0 — if AdornedInput focus styles change,
  // verify this override still wins correctly and the white gap still doesn't bleed.
  "&:has(input:focus-visible)": {
    boxShadow: "inset 0 0 0 {borderWidths.default} var(--shadow-color), 0 0 2px 3px {colors.blue.200}, 0 0 2px 4px {colors.blue.600} !important",
    boxShadowColor: "border.action.hero.selected.default !important"
  }
});
const joinedSplitRightCva = cva({
  base: {
    flex: "0.5",
    borderTopRightRadius: "{radii.obj.default}",
    borderBottomRightRadius: "{radii.obj.default}",
    paddingInlineEnd: 0,
    borderLeftWidth: "{borderWidths.xs}",
    borderLeftStyle: "solid"
  },
  variants: {
    error: {
      true: {
        borderLeftColor: "border.feedback.critical.hero",
        "&:hover:not(:focus-within)": {
          borderLeftColor: "AdornedInput.border.errorHover"
        }
      },
      false: {
        borderLeftColor: "border.muted",
        "&:hover:not(:focus-within)": {
          borderLeftWidth: 0
        }
      }
    }
  },
  defaultVariants: {
    error: false
  }
});
const joinedSplitRight = (error) => cx(joinedSplitSegment, joinedSplitRightCva({
  error
}));
const joinedSplitMoney = cx(joinedSplitSegment, css({
  flex: 1,
  paddingInlineStart: 0,
  borderTopLeftRadius: "{radii.obj.default}",
  borderBottomLeftRadius: "{radii.obj.default}"
}));
const joinedSplitAdornmentResetInlinePad = css({
  paddingInline: 0,
  paddingBlock: 0
});
const joinedSplitStartSymbol = css({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box",
  paddingBlock: "{spacing.AdornedInput.md.padding.vert}",
  paddingInline: "{spacing.default}",
  backgroundColor: "transparent",
  color: "AdornedInput.Adornment.default",
  borderTopLeftRadius: "{radii.obj.default}",
  borderBottomLeftRadius: "{radii.obj.default}"
});
const joinedSplitEndSymbol = css({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box",
  paddingBlock: "{spacing.AdornedInput.md.padding.vert}",
  paddingInline: "{spacing.default}",
  backgroundColor: "transparent",
  color: "AdornedInput.Adornment.default",
  borderTopRightRadius: "{radii.obj.default}",
  borderBottomRightRadius: "{radii.obj.default}"
});
export {
  joinedSplitAdornmentResetInlinePad,
  joinedSplitEndSymbol,
  joinedSplitMoney,
  joinedSplitRight,
  joinedSplitSegment,
  joinedSplitShell,
  joinedSplitStartSymbol
};
